import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  getInvoiceInfo(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/invoice/getUserInvoiceInfoByUserId",
      data,
      false
    );
  },
  saveInvoiceInfo(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/invoice/saveUserInvoiceInfo",
      data,
      false
    );
  },
  applyInvoice(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-order/invoice/userApplyInvoice",
      data,
      false
    );
  },
  getInvoiceStatus(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-order/invoice/getInvoiceDetailInfoRespDTO",
      data,
      false
    );
  },
  repealInvoice(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-order/invoice/userCancelApplyInvoice",
      data,
      false
    );
  },
};
